import type { FaireProductEntity } from "../../entity_types/product";

export const p_ufjavmwa64: FaireProductEntity = {
  token: "p_ufjavmwa64",
  type: "product",
  name: "Sabine 18K Gold Multi Stone Statement Ring",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/a44c5532fce4de2b6193bf03ecab5faa6278e9b264f7e43451d19bc04142ef49.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c4d2b08b740224b6c01dc868164509c5402befc69ba771f0052ee395706ee602.jpeg",
    "https://cdn.faire.com/fastly/1e640652d4b3d9ea5bb645d4972d142dbd0163a48d8abc9d666201554eeff191.jpeg",
  ],
  priceDollars: 9.94,
  description:
    "18K Gold Multi Stone Statement Ring\n18K Gold Plating\nBrass\nNatural Stones\nCubic Zirconia \nSize 7 Measurement: 0.682 Diameter/2.14 Circumference\n \n- Nickel-free, Lead-safe",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:40.822Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
